import React from 'react';
import { Link } from 'react-router-dom';
import { useActiveLeague } from '../../hooks/useActiveLeague';
import {
    REMATCH_NOT_READY_RETRY_DELAYS_MS,
    useQuickplayRematchNavigation
} from '../../hooks/useQuickplayRematchNavigation';

const POST_MATCH_SQUAD_GUIDANCE = 'Your transfer budget went into building this squad. Fine-tune your lineup and tactics on My Team, or drop a player in Transfers to free up funds for new signings.';

function QuickplayPostMatchActions({ matchStatus }) {
    const { activeLeague } = useActiveLeague();
    const {
        error,
        isStartingRematch,
        startRematch
    } = useQuickplayRematchNavigation();

    if (activeLeague?.gameMode !== 'quickplay' || matchStatus !== 'completed') {
        return null;
    }

    return (
        <section className="quickplay-post-match" aria-label="Quick Play next steps">
            <h3>What next?</h3>
            <p className="post-match-squad-guidance">
                {POST_MATCH_SQUAD_GUIDANCE}
            </p>
            <div className="quickplay-post-match-actions">
                <button
                    type="button"
                    className="submit-btn"
                    disabled={isStartingRematch}
                    onClick={startRematch}
                >
                    {isStartingRematch ? 'STARTING…' : 'REMATCH'}
                </button>
                <Link
                    className="submit-btn"
                    to={`/${activeLeague.slug}/transfers-players`}
                >
                    IMPROVE YOUR TEAM
                </Link>
            </div>
            {isStartingRematch ? (
                <p className="quickplay-post-match-status" role="status">
                    Confirming full-time and building a new opponent…
                </p>
            ) : null}
            {error ? <p className="error-message" role="alert">{error}</p> : null}
        </section>
    );
}

export {
    POST_MATCH_SQUAD_GUIDANCE,
    QuickplayPostMatchActions,
    REMATCH_NOT_READY_RETRY_DELAYS_MS
};
